export default __webpack_public_path__ + "images/VQ.7d8ed4c.png";